import React, { useState, useEffect, useContext } from 'react';
import Auxiliary from '../../util/Auxiliary';
import Title from '../../components/Title/Title';
import { ParamsContext } from '../Context/ParamsContext';
import axios from '../../util/Api';
import { message } from 'antd';
import Table from '../../components/Table/Basic';
import DateTime from '../../components/Formatter/DateTime';

const Index = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [displayed, setDisplayed] = useState(null);
  const [total, setTotal] = useState(null);

  const params = useContext(ParamsContext);

  useEffect(() => {
    fetchTapData();
  }, [params]);

  const fetchTapData = () => {
    setLoading(true);
    const url = `/tap/summary`;
    axios.get(url, { params: params }).then(resp => {
      setData(resp.data.taps);
      setTotal(resp.data.total);
      setDisplayed(resp.data.displayed);
      setLoading(false);
    }).catch(err => {
      message.error('Gagal memuat data monitoring');
    });
  }

  const columns = [
    {
      title: 'Kategori',
      dataIndex: 'category',
      key: 'category',
      // filter: true,
    },
    {
      title: 'Perusahaan',
      dataIndex: 'vendor',
      key: 'vendor',
      filter: true,
    },
    {
      title: 'Divisi Operasi',
      dataIndex: 'division',
      key: 'division',
      // filter: true,
    },
    {
      title: 'Proyek',
      dataIndex: 'project',
      key: 'project',
      filter: true,
    },
    {
      title: 'ID',
      dataIndex: 'number',
      key: 'number',
      filter: true,
    },
    {
      title: 'Nama',
      dataIndex: 'name',
      key: 'name',
      filter: true,
    },
    {
      title: 'Masuk',
      dataIndex: 'time_in',
      key: 'time_in',
      render: time_in => time_in ? <DateTime value={time_in} /> : null,
      sorter: true,
    },
    {
      title: 'Keluar',
      dataIndex: 'time_out',
      key: 'time_out',
      render: time_out => time_out ? <DateTime value={time_out} /> : null,
      sorter: true,
    },
    {
      title: 'Man Hours',
      dataIndex: 'man_hours',
      key: 'man_hours',
      render: man_hours => `${man_hours} Jam`
    },
  ];

  return (
    <Auxiliary>
      <Title>Monitoring</Title>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        total={total}
      />
    </Auxiliary>
  );
}

export default Index;